import {ApiError} from "../models/ApiError";

export function parseApiError(body: any): ApiError {
    return new ApiError(body.error.code, body.error.message);
}

export function createUnknownError(error: Error): ApiError {
    return new ApiError('UNKNOWN', error.toString());
}
